import {CommonModule} from '@angular/common';
import {SmSearchHighlightComponent} from '../sm-search-highlight/sm-search-highlight.component';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SmRichTooltipComponent} from './sm-rich-tooltip.component';

@NgModule({
  imports: [
    CommonModule,
    SmSearchHighlightComponent,
    IonicModule,
  ],
  declarations: [SmRichTooltipComponent],
  exports: [SmRichTooltipComponent],
})
export class SmRichTooltipModule {}
